import React from "react";
import { connect } from "react-redux";
import { PageHeader, Empty, Spin, Typography, Badge } from "antd";
import { PlusOutlined, UserOutlined, SearchOutlined, ShopOutlined, BarChartOutlined } from "@ant-design/icons";
import moment from "moment";
import "moment/locale/es";
import { ButtonItem, ModalItem, InputItem, SelectItem, SegmentedItem } from "../../../../Components/Items";
import useChatSoporte from "../Chat/useChatSoporte";
import useEsMovil from "../Chat/useEsMovil";
import TicketsMovil from "./TicketsMovil";
import ModalNuevoTicket from "../Chat/ModalNuevoTicket";
import HiloMensajesSoporte from "../Chat/HiloMensajesSoporte";
import InfoReporte from "../Chat/InfoReporte";
import TagFase from "../Chat/TagFase";
import TagRespuestaCliente from "../Chat/TagRespuestaCliente";
import AccionesSubido from "../Chat/AccionesSubido";
import AccionesPeticion from "../Chat/AccionesPeticion";
import ListaTicketsSoporte from "../Chat/ListaTicketsSoporte";
import { useAccesoSoporte } from "../Chat/accesoSoporte";
import BotonAyudaManuales from "../../../../Components/BotonAyudaManuales";
import AvisoHorario from "../Chat/AvisoHorario";
import { nombreDeUsuario } from "../Chat/nombreUsuario";
import { textoUltimoMensaje } from "../Chat/prefijoUltimoMensaje";
import {
  FASES_LABEL,
  FASES_COLOR_HEX,
  SOPORTE_TEMA,
  chatCerrado,
  textoChatCerrado,
} from "../Chat/fasesSoporte";

const { Title } = Typography;

moment.locale("es");

const ORDEN_FASES = ["en_revision", "pre_reporte", "rechazado", "por_hacer", "en_curso", "resuelto", "subido"];

const columnaDeFase = (fase) => (fase === "no_enviado" ? "rechazado" : fase);

const SIN_EMPRESA = "sin_empresa";

const TarjetaTicket = ({ ticket, onClick, mostrarReportero, esPropio, usuarioId }) => (
  <div
    onClick={onClick}
    style={{
      background: SOPORTE_TEMA.surface,
      border: `1px solid ${SOPORTE_TEMA.border}`,
      borderRadius: 8,
      padding: "10px 12px",
      marginBottom: 8,
      cursor: "pointer",
      boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
    }}
  >
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 6 }}>
      <span style={{ fontWeight: 600, fontSize: 13, color: SOPORTE_TEMA.textPrimary }}>
        {ticket.folio}
        {ticket.fase === "no_enviado" && <TagFase fase={ticket.fase} style={{ marginLeft: 6, fontSize: 10, lineHeight: "16px" }} />}
      </span>
      {/* Mensajes de soporte sin leer de este reporte. */}
      {ticket.noLeidosCliente > 0 && (
        <Badge count={ticket.noLeidosCliente} overflowCount={99} style={{ backgroundColor: SOPORTE_TEMA.primario }} />
      )}
    </div>
    <div
      style={{
        fontSize: 12,
        color: SOPORTE_TEMA.textPrimary,
        marginTop: 2,
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        wordBreak: "break-word",
      }}
    >
      {ticket.titulo}
    </div>
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        marginTop: 6,
        maxWidth: "100%",
        padding: "1px 8px",
        borderRadius: 12,
        fontSize: 10,
        backgroundColor: "#f4f5f7",
        color: "#5e6c84",
      }}
    >
      <ShopOutlined style={{ fontSize: 10, flexShrink: 0 }} />
      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {ticket.empresaId?.nombre || "Sin empresa"}
      </span>
    </div>
   
    {ticket.respuestaCliente && (
      <div style={{ marginTop: 6 }}>
        <TagRespuestaCliente respuesta={ticket.respuestaCliente} style={{ fontSize: 10, lineHeight: "16px" }} />
      </div>
    )}
    {mostrarReportero && (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
          marginTop: 6,
          maxWidth: "100%",
          padding: "1px 8px",
          borderRadius: 12,
          fontSize: 10,
          backgroundColor: esPropio ? "#f4f5f7" : "rgba(250, 140, 22, 0.14)",
          color: esPropio ? "#172b4d" : SOPORTE_TEMA.primarioFuerte,
        }}
      >
        <UserOutlined style={{ fontSize: 10, flexShrink: 0 }} />
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {esPropio ? "Tú" : nombreDeUsuario(ticket.usuarioId, "Otro usuario")}
        </span>
      </div>
    )}
    <div
      style={{
        fontSize: 11,
        color: SOPORTE_TEMA.textSecondary,
        marginTop: 4,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {textoUltimoMensaje(ticket, usuarioId)}
    </div>
    {ticket.ultimoMensajeFecha && (
      <div style={{ fontSize: 10, color: SOPORTE_TEMA.textSecondary, marginTop: 4 }}>
        {moment(ticket.ultimoMensajeFecha).format("DD/MM/YYYY HH:mm")}
      </div>
    )}
  </div>
);

const ColumnaFase = ({ fase, tickets, onSelect, mostrarReportero, usuarioId }) => (
  <div style={{ flex: "1 1 0", minWidth: 0, display: "flex", flexDirection: "column" }}>
    <div
      style={{
        backgroundColor: "#ffffff",
        borderRadius: 6,
        padding: "10px 12px",
        border: "1px solid #f0f0f0",
        borderTop: `4px solid ${FASES_COLOR_HEX[fase]}`,
        marginBottom: 5,
        boxShadow: "0 2px 5px rgba(0,0,0,0.02)",
      }}
    >
      <Title
        level={5}
        style={{
          margin: 0,
          textTransform: "uppercase",
          fontSize: 12,
          color: "#5e6c84",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 4,
        }}
      >
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {FASES_LABEL[fase]}
        </span>
        <span
          style={{
            backgroundColor: "#f4f5f7",
            padding: "2px 8px",
            borderRadius: 12,
            fontSize: 11,
            color: "#172b4d",
            flexShrink: 0,
          }}
        >
          {tickets.length}
        </span>
      </Title>
    </div>
    <div
      style={{
        flex: 1,
        backgroundColor: "#e6e6e636",
        maxHeight: "calc(100vh - 300px)",
        overflowY: "auto",
        padding: 6,
      }}
    >
      {tickets.length === 0 ? (
        <div style={{ fontSize: 12, color: SOPORTE_TEMA.textSecondary, padding: "8px 4px", textAlign: "center" }}>
          Sin tickets
        </div>
      ) : (
        tickets.map((ticket) => (
          <TarjetaTicket
            key={ticket._id}
            ticket={ticket}
            onClick={() => onSelect(ticket)}
            mostrarReportero={mostrarReportero}
            esPropio={String(ticket.usuarioId?._id || ticket.usuarioId) === String(usuarioId)}
            usuarioId={usuarioId}
          />
        ))
      )}
    </div>
  </div>
);

const Tickets = ({ headersToken, usuarioId, tipo, location, history }) => {
  const [modalNuevo, setModalNuevo] = React.useState(false);
  const [busqueda, setBusqueda] = React.useState("");
  const [empresaFiltro, setEmpresaFiltro] = React.useState(undefined);
  const [usuarioFiltro, setUsuarioFiltro] = React.useState(undefined);
  const esMovil = useEsMovil();
  const [pestana, setPestana] = React.useState(location?.state?.peticionId ? "peticiones" : "tickets");
  const { puedeRevisar } = useAccesoSoporte({ tipo, usuarioId, headersToken });
  const enPeticiones = puedeRevisar && pestana === "peticiones";
  const chat = useChatSoporte({ headersToken, chatAbierto: !enPeticiones, listaActiva: !enPeticiones });
  const peticiones = useChatSoporte({
    headersToken,
    chatAbierto: enPeticiones,
    modoPeticiones: true,
    listaActiva: enPeticiones,
    habilitado: !!puedeRevisar,
  });
  const vista = enPeticiones ? peticiones : chat;

  // Si llegamos desde el botón "Ver en grande" de la burbuja, abrir ese ticket.
  React.useEffect(() => {
    const ticketId = location?.state?.ticketId;
    if (ticketId) chat.seleccionarTicket({ _id: ticketId });
    const peticionId = location?.state?.peticionId;
    if (peticionId) peticiones.seleccionarTicket({ _id: peticionId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // El máster puede VER los reportes de sus usuarios hijos, pero no escribir
  // en su chat — el backend ya lo bloquea, esto solo oculta el composer.
  const esMaster = tipo === 0;

  const opcionesEmpresa = React.useMemo(() => {
    const porId = new Map();
    chat.tickets.forEach((t) => {
      const value = t.empresaId?._id ? String(t.empresaId._id) : SIN_EMPRESA;
      if (!porId.has(value)) porId.set(value, t.empresaId?.nombre || "Sin empresa");
    });
    return Array.from(porId, ([value, label]) => ({ value, label }));
  }, [chat.tickets]);

  const opcionesUsuario = React.useMemo(() => {
    const porId = new Map();
    chat.tickets.forEach((t) => {
      const id = String(t.usuarioId?._id || t.usuarioId || "");
      if (id && !porId.has(id)) {
        porId.set(id, id === String(usuarioId) ? "Tú" : nombreDeUsuario(t.usuarioId, "Otro usuario"));
      }
    });
    return Array.from(porId, ([value, label]) => ({ value, label }));
  }, [chat.tickets, usuarioId]);

  const ticketsFiltrados = React.useMemo(() => {
    const texto = busqueda.trim().toLowerCase();
    return chat.tickets.filter((t) => {
      if (empresaFiltro) {
        const value = t.empresaId?._id ? String(t.empresaId._id) : SIN_EMPRESA;
        if (value !== empresaFiltro) return false;
      }
      if (usuarioFiltro && String(t.usuarioId?._id || t.usuarioId) !== usuarioFiltro) return false;
      if (texto) {
        const campos = `${t.folio || ""} ${t.titulo || ""} ${t.descripcion || ""} ${t.empresaId?.nombre || ""} ${nombreDeUsuario(t.usuarioId, "")}`;
        if (!campos.toLowerCase().includes(texto)) return false;
      }
      return true;
    });
  }, [chat.tickets, busqueda, empresaFiltro, usuarioFiltro]);

  const hayFiltros = !!busqueda || !!empresaFiltro || !!usuarioFiltro;
  const limpiarFiltros = () => {
    setBusqueda("");
    setEmpresaFiltro(undefined);
    setUsuarioFiltro(undefined);
  };

  const columnas = ORDEN_FASES.map((fase) => ({
    fase,
    tickets: ticketsFiltrados.filter((t) => columnaDeFase(t.fase) === fase),
  }));
  const ticketAjeno =
    !enPeticiones &&
    esMaster &&
    !!vista.ticketActivo &&
    String(vista.ticketActivo.usuarioId?._id || vista.ticketActivo.usuarioId) !== String(usuarioId);
  const cerrado = chatCerrado(vista.ticketActivo?.fase);
  const peticionRevisada = enPeticiones && !!vista.ticketActivo && vista.ticketActivo.fase !== "en_revision";
  const soloLectura = ticketAjeno || cerrado || peticionRevisada;
  const textoSoloLectura = cerrado
    ? textoChatCerrado(vista.ticketActivo.fase)
    : peticionRevisada
      ? "Esta petición ya fue revisada."
      : undefined;

  const responderRespuesta = (respuesta) => chat.responderSubido(chat.ticketActivo._id, respuesta);
  const puedeResponderSubido = !enPeticiones && !!chat.ticketActivo && !ticketAjeno;

  const alRevisarPeticion = () => {
    peticiones.volverALista();
    peticiones.cargarTickets();
  };

  const accionesPeticion = enPeticiones && vista.ticketActivo && (
    <AccionesPeticion ticket={vista.ticketActivo} headersToken={headersToken} onRevisada={alRevisarPeticion} />
  );

  const selectorPestana = puedeRevisar ? (
    <SegmentedItem
      value={pestana}
      onChange={setPestana}
      options={[
        {
          value: "tickets",
          label: (
            <span>
              Mis tickets <Badge count={chat.noLeidos} size="small" overflowCount={99} />
            </span>
          ),
        },
        {
          value: "peticiones",
          label: (
            <span>
              Peticiones de soporte <Badge count={peticiones.noLeidos} size="small" overflowCount={99} />
            </span>
          ),
        },
      ]}
    />
  ) : null;

  // En celular el tablero de 6 columnas es ilegible: se cambia por la lista de
  // conversaciones. El modal de reportar es el mismo en las dos ramas.
  if (esMovil) {
    return (
      <>
        <TicketsMovil
          tickets={enPeticiones ? peticiones.tickets : ticketsFiltrados}
          loading={vista.loadingTickets}
          ordenFases={ORDEN_FASES}
          columnaDeFase={columnaDeFase}
          usuarioId={usuarioId}
          esMaster={esMaster}
          noLeidos={vista.noLeidos}
          onSeleccionar={vista.seleccionarTicket}
          onNuevoTicket={() => setModalNuevo(true)}
          ticketActivo={vista.ticketActivo}
          mensajes={vista.mensajes}
          loadingMensajes={vista.loadingMensajes}
          enviando={vista.enviando}
          onVolver={vista.volverALista}
          onEnviarMensaje={vista.enviarMensaje}
          soloLectura={soloLectura}
          textoSoloLectura={textoSoloLectura}
          modoPeticiones={enPeticiones}
          selectorPestana={selectorPestana}
          accionesPeticion={accionesPeticion}
          puedeResponderSubido={puedeResponderSubido}
          respondiendo={chat.respondiendo}
          onResponderSubido={responderRespuesta}
        />
        <ModalNuevoTicket
          visible={modalNuevo}
          creando={chat.creando}
          onCancel={() => setModalNuevo(false)}
          onCrear={(formData, onExito) => {
            setPestana("tickets");
            chat.crearPreReporte(formData, onExito);
          }}
        />
      </>
    );
  }

  return (
    <>
      <PageHeader
        title={
          <span>
            Tickets de Soporte
            {chat.noLeidos > 0 && (
              <Badge
                count={chat.noLeidos}
                overflowCount={99}
                style={{ backgroundColor: SOPORTE_TEMA.primario, marginLeft: 10 }}
                title={`${chat.noLeidos} mensaje(s) de soporte sin leer`}
              />
            )}
          </span>
        }
        style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
        footer={selectorPestana}
        extra={
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <AvisoHorario />
            {/* El reporte entregable es del máster: consolida a toda la empresa. */}
            {esMaster && (
              <ButtonItem
                azul
                icon={<BarChartOutlined />}
                onClick={() => history.push("/panel/reporteSoporte")}
                className="botonAgregar"
              >
                Ver reporte
              </ButtonItem>
            )}
            <ButtonItem className="botonAgregar" type="primary" naranja icon={<PlusOutlined />} onClick={() => setModalNuevo(true)}>
              Levantar un ticket
            </ButtonItem>
            <BotonAyudaManuales modulo={puedeRevisar ? "soporteAdministrador" : "soporteUsuario"} />
          </div>
        }
      />

      {enPeticiones ? (
        <div style={{ background: "#fff", borderRadius: 12, boxShadow: "0 1px 4px rgba(0,0,0,0.08)", overflow: "hidden" }}>
          <ListaTicketsSoporte
            tickets={peticiones.tickets}
            loading={peticiones.loadingTickets}
            onSelect={peticiones.seleccionarTicket}
            mostrarReportero
            usuarioId={usuarioId}
            modoPeticiones
            anchoTexto="100%"
          />
        </div>
      ) : (
        <>
          {chat.tickets.length > 0 && (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 8,
                padding: "8px 12px",
                marginBottom: 10,
                backgroundColor: "#fff",
                border: "1px solid rgb(235, 237, 240)",
                borderRadius: 6,
              }}
            >
              <InputItem
                placeholder="Buscar por folio, título o descripción"
                prefix={<SearchOutlined style={{ color: SOPORTE_TEMA.textSecondary }} />}
                allowClear
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
                style={{ width: 320 }}
              />
              {opcionesEmpresa.length > 1 && (
                <SelectItem
                  placeholder="Todas las empresas"
                  allowClear
                  value={empresaFiltro}
                  options={opcionesEmpresa}
                  onChange={(value) => setEmpresaFiltro(value)}
                  style={{ width: 240 }}
                />
              )}
              {esMaster && opcionesUsuario.length > 1 && (
                <SelectItem
                  placeholder="Todos los usuarios"
                  allowClear
                  value={usuarioFiltro}
                  options={opcionesUsuario}
                  onChange={(value) => setUsuarioFiltro(value)}
                  style={{ width: 240 }}
                />
              )}
              {hayFiltros && (
                <ButtonItem type="default" siena size="small" onClick={limpiarFiltros}>
                  Limpiar filtros
                </ButtonItem>
              )}
              <span style={{ marginLeft: "auto", fontSize: 12, color: SOPORTE_TEMA.textSecondary }}>
                {ticketsFiltrados.length} de {chat.tickets.length} reportes
              </span>
            </div>
          )}

          {chat.loadingTickets || chat.tickets.length === 0 ? (
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                padding: 20,
                boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
              }}
            >
              {chat.loadingTickets ? (
                <div style={{ textAlign: "center", padding: 40 }}>
                  <Spin />
                </div>
              ) : (
                <Empty description="Aún no has levantado ningún ticket" style={{ margin: "40px 0" }}>
                  <ButtonItem type="primary" naranja icon={<PlusOutlined />} onClick={() => setModalNuevo(true)}>
                    Levantar un ticket
                  </ButtonItem>
                  <div style={{ display: "flex", justifyContent: "center", marginTop: 14 }}>
                    <AvisoHorario />
                  </div>
                </Empty>
              )}
            </div>
          ) : (
            <div style={{ display: "flex", flexWrap: "nowrap", width: "100%", gap: 6, paddingBottom: 10 }}>
              {columnas.map(({ fase, tickets }) => (
                <ColumnaFase
                  key={fase}
                  fase={fase}
                  tickets={tickets}
                  onSelect={chat.seleccionarTicket}
                  mostrarReportero={esMaster}
                  usuarioId={usuarioId}
                />
              ))}
            </div>
          )}
        </>
      )}

      <ModalNuevoTicket
        visible={modalNuevo}
        creando={chat.creando}
        onCancel={() => setModalNuevo(false)}
        onCrear={(formData, onExito) => {
          setPestana("tickets");
          chat.crearPreReporte(formData, onExito);
        }}
      />

      <ModalItem
        visible={!!vista.ticketActivo}
        title={
          vista.ticketActivo
            ? `${vista.ticketActivo.folio} — ${vista.ticketActivo.titulo}${
                esMaster || enPeticiones ? ` · ${nombreDeUsuario(vista.ticketActivo.usuarioId)}` : ""
              }`
            : ""
        }
        onCancel={vista.volverALista}
        footer={null}
        destroyOnClose
        width={820}
        spinning={false}
      >
        {vista.ticketActivo && (
          <>
            <div style={{ marginBottom: 12, display: "flex", gap: 6, alignItems: "center" }}>
              <TagFase fase={vista.ticketActivo.fase} />
              <TagRespuestaCliente respuesta={vista.ticketActivo.respuestaCliente} />
            </div>
            {puedeResponderSubido && (
              <div style={{ marginBottom: 12 }}>
                <AccionesSubido
                  ticket={chat.ticketActivo}
                  guardando={chat.respondiendo}
                  onResponder={responderRespuesta}
                />
              </div>
            )}
            {accionesPeticion && <div style={{ marginBottom: 12 }}>{accionesPeticion}</div>}
            {/* Chat a la izquierda, info del reporte a la derecha */}
            <div style={{ display: "flex", gap: 20 }}>
              <div
                style={{
                  flex: "1 1 55%",
                  minWidth: 0,
                  height: 420,
                  display: "flex",
                  border: `1px solid ${SOPORTE_TEMA.border}`,
                  borderRadius: 6,
                }}
              >
                <HiloMensajesSoporte
                  mensajes={vista.mensajes}
                  loading={vista.loadingMensajes}
                  enviando={vista.enviando}
                  onEnviar={vista.enviarMensaje}
                  perspectivaAgente={false}
                  usuarioId={usuarioId}
                  soloLectura={soloLectura}
                  textoSoloLectura={textoSoloLectura}
                />
              </div>
              <div style={{ flex: "1 1 45%", minWidth: 0, maxHeight: 420, overflowY: "auto", paddingRight: 4 }}>
                <InfoReporte ticket={vista.ticketActivo} />
              </div>
            </div>
          </>
        )}
      </ModalItem>
    </>
  );
};

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  usuarioId: state.user.usuarioId,
  tipo: state.user.tipo,
});

export default connect(mapStateToProps)(Tickets);
